import api from "@core/plugins/api";
import { ArrayHelpers } from "@core/helpers";
import { CloseRecruitmentDemandDTO, ReviewExtraDTO, ScheduleExtraDTO, NoShowReasonDTO } from "@core/dto";

const confirmScheduleUrl = (shiftId) => `/api/et/releves-etab/${shiftId}`;
const declareExtraMissingFromScheduleUrl = (shiftId) => `/api/et/releves-etab/${shiftId}`;
const extraReviewUrl = () => `/api/et/list/extras/notes`;
const extraSchedulesUrl = () => `/api/et/releves-etab`;
const ignoreReviewUrl = (demandId, extraId) => `/api/et/ignoreRating/etab/${demandId}/${extraId}`;
const reviewDemandUrl = () => `/cdi-review/et/finalize-demand`;
const reviewExtraAEUrl = () => `/api/et/finalisation/mission`;
const reviewExtraMERUrl = () => `/api/et/finalisation`;
const schedulesReviewsAmountUrl = () => `/api/et/releves-etab/rating-etab/number`;
const updateScheduleUrl = (shiftId) => `/api/et/releves-etab/${shiftId}`;
const getNoShowReasonsUrl = () => `/et/candidate-shift-no-show/reasons`;
const postNoShowReasonUrl = (shiftId) => `/et/candidate-shift-no-show/${shiftId}`;

export class SurveyService {
  static async getSurveyAmount() {
    try {
      const response = await api.private.get(schedulesReviewsAmountUrl());
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  static async getExtraShedules() {
    try {
      const response = await api.private.get(extraSchedulesUrl());
      return ArrayHelpers.ensureArray(response.data);
    } catch (error) {
      throw error;
    }
  }

  static async getExtraReviews() {
    try {
      const response = await api.private.get(extraReviewUrl());
      return ArrayHelpers.ensureArray(response.data);
    } catch (error) {
      throw error;
    }
  }

  static async postDemandReview({ demandId, comment }) {
    try {
      const dto = new CloseRecruitmentDemandDTO({ demandId, comment });
      const requestData = dto.prepareCloseRecruitmentDemandData();
      const { data } = await api.private.post(reviewDemandUrl(), requestData);
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async postExtraReview({ review }) {
    try {
      const dto = new ReviewExtraDTO(review);
      const data = dto.prepareReviewData();
      let response;
      if (dto.isAE()) {
        response = await api.private.post(reviewExtraAEUrl(), data);
      }
      if (response === undefined) {
        throw new Error("WRONG RECRUITMENT TYPE");
      }
      return response && response.data;
    } catch (error) {
      throw error;
    }
  }

  static async ignoreReview({ review }) {
    try {
      const dto = new ReviewExtraDTO(review);
      const demandId = dto.getDemandId();
      const extraId = dto.getExtraId();
      const response = await api.private.post(ignoreReviewUrl(demandId, extraId));
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  static async declareExtraMissingFromSchedule({ schedule }) {
    try {
      const dto = new ScheduleExtraDTO(schedule);
      const shiftId = dto.getShiftId();
      const data = dto.prepareDeclareExtraMissingData();
      const response = await api.private.post(declareExtraMissingFromScheduleUrl(shiftId), data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  static async declareExtraMissingFromReview({ review }) {
    try {
      const dto = new ReviewExtraDTO(review);
      const data = dto.prepareDeclareExtraMissingData();
      // TODO have to delete ???
      const response = await api.private.post(reviewExtraMERUrl(), data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  static async confirmSchedule({ schedule }) {
    try {
      const dto = new ScheduleExtraDTO(schedule);
      const shiftId = dto.getShiftId();
      const data = dto.prepareConfirmScheduleData();
      const response = await api.private.post(confirmScheduleUrl(shiftId), data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  static async updateSchedule({ schedule }) {
    try {
      const dto = new ScheduleExtraDTO(schedule);
      const shiftId = dto.getShiftId();
      const data = dto.prepareUpdateScheduleData();
      const response = await api.private.post(updateScheduleUrl(shiftId), data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  static async postNoShowReason({ shiftId, reasonId }) {
    try {
      const dto = new NoShowReasonDTO({ reasonId });
      const dtoData = dto.prepareNoShowReasonData();
      const { data } = await api.private.put(postNoShowReasonUrl(shiftId), dtoData);
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async getNoShowReasons() {
    try {
      const { data } = await api.private.get(getNoShowReasonsUrl());
      return ArrayHelpers.ensureArray(data);
    } catch (error) {
      throw error;
    }
  }
}
